export const DAILY_FREE_PLAY_LIMIT = 3;

export const dailyFreePlayLimitMessage = (textosShow = {}) => (
  textosShow.limiteglobalpartidasgratis ||
  'You have reached the daily limit of 3 free games across all games. Subscribe to continue playing.'
);
